import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';

const StaindBackground = ({ children, className }) => (
  <Section className={className}>
    <Container small>
      <BackgroundImage>
        {children}
      </BackgroundImage>
    </Container>
  </Section>
);

const Section = styled.section`
  color: white;
  text-align: center;
  background-color: ${(props) => props.theme.secondaryColor};
  ${Container} {
    padding: 0;
    @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
      padding-left: ${(props) => props.theme.grid.gap};
      padding-right: ${(props) => props.theme.grid.gap};
    }
  }
`;

export const BackgroundImage = styled.div`
  height: 394px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url("https://res.cloudinary.com/htkgpamks/image/upload/v1564139604/social-stain_ygn8w3.svg");
`;

export default styled(StaindBackground)``;
